module.exports = __webpack_public_path__ + "img/btn-upload.a9916ee1.png";